import { useMemo, useState } from 'react';
import { isRecommendationsSection } from '../../typeGuards';
export default function useActiveSections(query, sections, podsData, zeroStateSections) {
    const showZeroStateSections = !query.length && !!zeroStateSections?.length;
    const [activeSections, setActiveSections] = useState(showZeroStateSections ? zeroStateSections : sections);
    // Merge Recommendation Pods Display Name from Dashboard
    const activeSectionsTransformed = useMemo(() => activeSections.map((config) => {
        const mergedConfig = config;
        if (isRecommendationsSection(config)) {
            const podData = podsData?.[config.podId];
            const libraryDisplayName = config.displayName;
            const dashboardDisplayName = podData?.displayName;
            mergedConfig.displayName = libraryDisplayName || dashboardDisplayName;
        }
        return mergedConfig;
    }), [activeSections, podsData]);
    return {
        activeSections: activeSectionsTransformed,
        showZeroStateSections,
        setActiveSections,
    };
}
